import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactModal from 'react-modal';

export class RecommendationModal extends React.PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    closeOnOverlayClick: PropTypes.bool,
  };

  static defaultProps = {
    closeOnOverlayClick: true,
  };

  componentDidMount() {
    ReactModal.setAppElement(document.body);
  }

  render() {
    const {
      isOpen,
      onCancel,
      closeOnOverlayClick,
    } = this.props;

    return (
      <ReactModal
        isOpen={isOpen}
        onRequestClose={onCancel}
        shouldCloseOnOverlayClick={closeOnOverlayClick}
        overlayClassName="recommendation-modal-overlay react-modal-overlay"
        className={classNames('recommendation-modal', 'react-modal')}
      >
        {this.props.children}
      </ReactModal>
    );
  }
}
